module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/store_images/4@2x_231fb72e88a5817c4b5838d76edf5dc7.png";